import React, { useState, useContext, useEffect } from "react"
import {useLocation} from "react-router-dom"

// context 
import {CatalogueContext, SearchContext} from "../../../../context"

// components
import {Button} from "../../../controls"
import FilterToggle from "./FilterToggle"
import PriceRange from "./PriceRange"

// styling & icons
import "./Filter.scss"
import {FilterMale as IconMale, FilterFemale as IconFemale, FilterCouple as IconCouple} from "../../../../images/js"


// custom hook that build on useLocation to parse the query string and get ?tags value
function useQueriedTags() {
  const query = new URLSearchParams(useLocation().search);
  return query.get("t");
}
function useQueriedTagsTitle() {
  const query = new URLSearchParams(useLocation().search);
  return query.get("tt");
}


/**
 * 
 * @param {*} position: either 'sidebar' or 'console' 
 */
function Filter({position}) {
  // state
  const [expanded, setExpanded] = useState(false)
  const [hasFilteredItems, setHasFilteredItems] = useState(false)

  // context
  const CC = useContext(CatalogueContext)
  const SC = useContext(SearchContext)

  // get queried tags
  const queriedTags = useQueriedTags();
  const queriedTagsTitle = useQueriedTagsTitle();

  // side effect: search result changed
  useEffect(() => {
    if(SC.subcatalogue === "singles") {
      setHasFilteredItems(SC.result.length !== CC.activities.standard.length);
    }
    else {
      setHasFilteredItems(SC.resultPackages.length !== CC.activityPackages.length);
    }
    
  }, [SC.result, SC.resultPackages])

  // side effect: filter text changed
  useEffect(() => {
    if((SC.filter.text || "").trim().length > 0) {
      // 
    }
  }, [SC.filter.text])

  // side effect: tags in the query string changed (e.g. /?tags=wellness,frauen)
  useEffect(() => {
    if(queriedTags && CC.isReady) {
      const tags = queriedTags.split(",").map(t => t.trim().toLowerCase()).filter(t => t.length > 0);
      SC.filterByTags(tags, queriedTagsTitle);
    }
  }, [queriedTags, CC.isReady]);

  // handlers
  const onPriceRangeChange = (priceRange) => {
    SC.filterByKey("priceRange", priceRange)
  }
  const onToggle = ({group, item, active}) => {
    SC.toggle(group, item, active)
  }

  // render
  let count = null
  let resetButton = null
  if(hasFilteredItems) {
    if(SC.subcatalogue === "singles") {
      count = (
        <div className="c-filter-count">
          {SC.result.length} von {CC.activities.standard.length} Erlebnissen
        </div>
      )
    }
    else {
      count = (
        <div className="c-filter-count">
          {SC.resultPackages.length} von {CC.activityPackages.length} Erlebnis-Kombinationen
        </div>
      )
    }
    
    resetButton = (
      <Button 
        onClick={() => {
          SC.reset()
          setExpanded(false)
        }} 
        
        kind="ok"
      >
        Filter löschen
      </Button>
    )
  }

  let icons = { "women":<IconFemale />, "couples":<IconCouple />, "men":<IconMale />}
  let genders = SC.toggles.genders.map(g => <FilterToggle timestamp={SC.timestamp} key={g.tag} label={g.label} icon={icons[g.key]} group="genders" item={g.tag} onChange={onToggle} className={g.key} />)
  let categories = SC.toggles.categories.map(g => <FilterToggle key={g.tag} label={g.label} group="categories" item={g.tag} onChange={onToggle} />)
  let regions = SC.toggles.regions.map(g => <FilterToggle key={g.code} label={g.label} group="regions" item={g.code} onChange={onToggle} />)
  //let kinds = SC.toggles.kinds.map(g => <FilterToggle key={g.value} label={g.label} group="kinds" item={g.value} onChange={onToggle} />)

  // action buttons
  let actions
  if(expanded) {
    actions = (
      <div className="c-filter-actions">
        {resetButton}
          <Button 
            onClick={() => setExpanded(false)} 
            kind="ok"
          >
            Filter anwenden
        </Button>
      </div>
    )
  }
  else {
    actions = (
      <div className="c-filter-actions">
        {resetButton}
        <Button onClick={() => setExpanded(true)}>{hasFilteredItems ? "Filter anpassen" : "Filter anzeigen"}</Button>
      </div>
    )
  }

  // content
  let content
  if(expanded || position==="sidebar") {
    let searchText = null
    if(SC.filter && (SC.filter.text || "").trim().length > 0) {
      searchText = <div className="c-filter-text">Suchbegriff: {SC.filter.text}</div>
    }
    const filter_genders = SC.subcatalogue === "singles" ? <div className="c-filter-genders">{genders}</div> : null;
    const filter_categories = SC.subcatalogue === "singles" ? <div className="c-filter-categories">{categories}</div> : null;
    content = (
      <div className="c-filter-content expanded">
        {filter_genders}
        {filter_categories}
        {/* <div className="c-filter-kinds">{kinds}</div> */}
        {regions.length > 1 ? <div className="c-filter-regions">{regions}</div> : null}
        <div className="c-filter-price">
          <PriceRange onPriceRangeChange={onPriceRangeChange} min={SC.filter.priceRange.min} max={SC.filter.priceRange.max} />
        </div>
        {searchText}
      </div>
    )
  }
  else {
    content = <div className="c-filter-content collapsed"></div>
  }
  

  if(position === "sidebar") {
    return (
      <div className="c-filter sidebar">
        {content}
        {count}
        {resetButton}
      </div>
    )
  }
  else {
    return (
      <div className="c-filter console">
        {count}
        {content}
        {actions}
      </div>
    )
  }
}

export default Filter